import { TrashIcon } from '@heroicons/react/24/outline';
import Button from 'components/inputs/button';

type FootprintResetButtonProps = Readonly<{
  onReset: () => void;
}>;

export default function FootprintResetButton({
  onReset
}: FootprintResetButtonProps) {
  return (
    <Button
      color='white'
      text='Reset Footprint'
      onClick={onReset}
      icon={TrashIcon}
      iconSize='sm'
      fullWidth
    />
  );
}
